import * as Types from '../actions/Types'
import * as Constants from '../../helpers/Constants'

const INITIAL_STATE = {
  alert: {
    show: false,
    header: '',
    text: '',
    type: Constants.ONE_BUTTON,
    firstButton: { title: '', onPress: () => {} },
    secondButton: { title: '', onPress: () => {} },
    thirdButton: { title: '', onPress: () => {} }
  },
  createCorparationModal: {
    show: false
  },
  snackbar: {
    show: false,
    message: ''
  }
}

export default (state = INITIAL_STATE, action) => {
  const { payload, type } = action

  switch (type) {
    case Types.SHOW_ALERT:
      return {
        ...state,
        alert: {
          show: true,
          header: payload.header,
          text: payload.text,
          type: payload.type,
          firstButton: payload.firstButton,
          secondButton: payload.secondButton,
          thirdButton: payload.thirdButton
        }
      }
    case Types.HIDE_ALERT:
      return {
        ...state,
        alert: {
          ...state.alert,
          show: false
        }
      }
    case Types.SHOW_CREATE_CORPARATION_MODAL:
      return {
        ...state,
        createCorparationModal: {
          ...state.createCorparationModal,
          show: true
        }
      }
    case Types.HIDE_CREATE_CORPARATION_MODAL:
      return {
        ...state,
        createCorparationModal: {
          ...state.createCorparationModal,
          show: false
        }
      }
    case Types.SHOW_SNACKBAR:
      return {
        ...state,
        snackbar: {
          show: true,
          message: payload
        }
      }
    case Types.HIDE_SNACKBAR:
      return {
        ...state,
        snackbar: {
          ...state.snackbar,
          show: false
        }
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/components/reducers/Config.js